import { motion } from "framer-motion";
import { Building2, User, Server, ShieldCheck, Cookie, Scale } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

const SECTIONS = [
  {
    icon: Building2,
    title: "Éditeur du site",
    content: [
      "SARL EG 6.1 — Société à responsabilité limitée au capital de 10 000 €",
      "SIRET : 853 682 482 00015 — Code NAF : 4321A (travaux d'installation électrique dans tous locaux)",
      `Siège : ${CONTACT.addressLine1}, ${CONTACT.addressLine2}`,
      `Téléphone : ${CONTACT.phone} — Email : ${CONTACT.email}`,
      `Gérants : ${CONTACT.founders.join(" et ")}`,
    ],
  },
  {
    icon: User,
    title: "Directeur de la publication",
    content: [`${CONTACT.founders.join(" et ")}, en qualité de co-gérants de la SARL EG 6.1.`],
  },
  {
    icon: Server,
    title: "Hébergement",
    content: [
      "Ce site est hébergé sur la plateforme Emergent (emergent.sh).",
      "Les données techniques nécessaires à l'affichage du site sont traitées par l'hébergeur dans le cadre de son activité.",
    ],
  },
  {
    icon: ShieldCheck,
    title: "Données personnelles (RGPD)",
    content: [
      "Ce site ne comporte aucun formulaire de collecte et n'utilise aucun cookie de suivi publicitaire.",
      "Si vous nous contactez par téléphone ou par email, les informations que vous nous transmettez sont utilisées uniquement pour répondre à votre demande et établir vos devis. Elles ne sont ni cédées, ni vendues à des tiers.",
      "Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer : " + CONTACT.email + ".",
    ],
  },
  {
    icon: Cookie,
    title: "Cookies",
    content: [
      "Ce site n'émet aucun cookie de mesure d'audience ou de ciblage publicitaire soumis à consentement.",
    ],
  },
  {
    icon: Scale,
    title: "Propriété intellectuelle & médiation",
    content: [
      "L'ensemble des contenus du site (textes, visuels, logo EG 6.1) est la propriété exclusive de la SARL EG 6.1. Toute reproduction sans autorisation est interdite.",
      "Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, en cas de litige non résolu, le consommateur peut recourir gratuitement à un médiateur de la consommation. Médiateur retenu par l'entreprise : à compléter par la SARL EG 6.1.",
    ],
  },
];

const MentionsLegales = () => (
  <main data-testid="mentions-legales-page" className="pt-20">
    <section className="relative overflow-hidden circuit-bg grain py-20 sm:py-28">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(15,52,140,0.08),transparent_55%)]" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="flex items-center gap-3 text-xs font-mono uppercase tracking-[0.28em] text-brand-blue"
        >
          <span className="h-px w-10 bg-brand-blue/70" />
          Informations légales
        </motion.p>
        <h1 data-testid="mentions-legales-title" className="mt-8 font-display text-4xl sm:text-6xl font-black uppercase leading-[0.95] tracking-tight">
          <MaskedLines
            delay={0.3}
            lines={[
              <span key="a" className="text-ink">Mentions</span>,
              <span key="b" className="text-brand-red glow-red">légales.</span>,
            ]}
          />
        </h1>
      </div>
    </section>

    <section className="py-16 sm:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.05}>
            <article
              data-testid={`legal-section-${i}`}
              className="rounded-2xl border border-slate-200 bg-white p-8 shadow-[0_4px_24px_rgba(15,52,140,0.06)]"
            >
              <h2 className="flex items-center gap-3 font-display text-xl font-bold text-ink">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#eef3fb] text-brand-blue">
                  <s.icon className="h-5 w-5" />
                </span>
                {s.title}
              </h2>
              <div className="mt-4 space-y-2.5">
                {s.content.map((line, j) => (
                  <p key={j} className="text-sm leading-relaxed text-slate-700">
                    {line}
                  </p>
                ))}
              </div>
            </article>
          </Reveal>
        ))}
        <Reveal delay={0.2}>
          <p className="text-center text-xs text-slate-500">
            Dernière mise à jour : septembre 2026 — SARL EG 6.1, tous droits réservés.
          </p>
        </Reveal>
      </div>
    </section>
  </main>
);

export default MentionsLegales;
